import { Button } from "@tblabs/truffle";


export class PrimaryButton extends Button
{
    constructor(label: string, action?: (self: PrimaryButton) => void)
    {
        super(label, action);
        
        this.Class("button primary2");
    }
}
